
const LimitInfo = function(props) {
	let dailyUsage = props.dailyUsage || 0;
	let dailyLimit = props.dailyLimit || 0;
	let monthlyUsage = props.monthlyUsage || 0;
	let monthlyLimit = props.monthlyLimit || 0;
	let plan = props.planName || '';

	let daily = dailyLimit ? (<li><b>Daily limit:</b> {dailyUsage}/{dailyLimit}</li>) : null;
	let monthly = monthlyLimit ? (<li><b>Monthly limit:</b> {monthlyUsage}/{monthlyLimit}</li>) : null;
	let planInfo = plan ? (<li><b>Plan name:</b> {plan}</li>) : null;

	return (
		<ul className="summary">{daily}{monthly}{planInfo}</ul>
	)
}

export default LimitInfo;